import { createSlice } from '@reduxjs/toolkit';

import { handleGetAthleteRoleGroups } from './actions';
import { IAthleteRoleGroupsState } from './slice.interface';

const initialState: IAthleteRoleGroupsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const athleteRoleGroupsSlice = createSlice({
  name: 'athlete-role-groups',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetAthleteRoleGroups.pending, (state: IAthleteRoleGroupsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAthleteRoleGroups.rejected, (state: IAthleteRoleGroupsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAthleteRoleGroups.fulfilled, (state: IAthleteRoleGroupsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export default athleteRoleGroupsSlice.reducer;
